import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1fd4981e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=1fd4981e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd4981e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fd4981e')) {
      api.createRecord('1fd4981e', component.options)
    } else {
      api.reload('1fd4981e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1fd4981e&scoped=true&", function () {
      api.rerender('1fd4981e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/newDashboard/index.vue"
export default component.exports